import { pane } from '../../../../APP/page/pane/PANE.js';
import PANELOADER from '../../../../APP/page/paneloader/PANELOADER.js';
import PANE_Home_Index from '../../../../APP/page/paneloader/paneloaders/PANELOADER_HOME/PANE_Home_Index.js';
import PANE_Home_Contact from '../../../../APP/page/paneloader/paneloaders/PANELOADER_HOME/PANE_Home_Contact.js';
import PANE_Home_Conduct from '../../../../APP/page/paneloader/paneloaders/PANELOADER_HOME/PANE_Home_Conduct.js';
import PANE_Home_Faq from '../../../../APP/page/paneloader/paneloaders/PANELOADER_HOME/PANE_Home_Faq.js';
import PANE_Home_Review from '../../../../APP/page/paneloader/paneloaders/PANELOADER_HOME/PANE_Home_Review.js';
import PANE_Home_List from '../../../../APP/page/paneloader/paneloaders/PANELOADER_HOME/PANE_Home_List.js';
export default class PANELOADER_HOME extends PANELOADER {
    constructor(page, model) {
        super(page, model);
    }
    paneSwitch(name) {
        switch (name) {
            case 'index': {
                this.page.horizontal.center.addChild(new PANE_Home_Index(this.page.horizontal.center, pane()));
                break;
            }
            case 'contact': {
                this.page.horizontal.center.addChild(new PANE_Home_Contact(this.page.horizontal.center, pane()));
                break;
            }
            case 'conduct': {
                this.page.horizontal.center.addChild(new PANE_Home_Conduct(this.page.horizontal.center, pane()));
                break;
            }
            case 'faq': {
                this.page.horizontal.center.addChild(new PANE_Home_Faq(this.page.horizontal.center, pane()));
                break;
            }
            case 'review': {
                this.page.horizontal.center.addChild(new PANE_Home_Review(this.page.horizontal.center, pane()));
                break;
            }
            case 'list': {
                this.page.horizontal.center.addChild(new PANE_Home_List(this.page.horizontal.center, pane()));
                break;
            }
            default:
                console.log('Unable to load PANE::' + name);
        }
    }
}
